import { useState, useEffect, useCallback } from "react";
import { Container, Row } from "react-bootstrap";
import Particle from "../Particle";
import { AiOutlineDownload, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Helmet } from "react-helmet-async";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const RESUME_URL = process.env.PUBLIC_URL + "/Vedant_Gaidhane_DevOps_Engineer_2yrs.pdf";

const btnStyle = {
  display: "inline-flex", alignItems: "center", gap: 8,
  background: "linear-gradient(135deg, var(--primary), #8b5cf6)",
  color: "#fff", borderRadius: "10px",
  padding: "0.65rem 1.6rem",
  fontWeight: 600, fontSize: "0.92rem",
  textDecoration: "none",
  boxShadow: "0 4px 18px rgba(108,99,255,0.30)",
  transition: "all 0.22s ease",
};

function DownloadBtn() {
  return (
    <div style={{ textAlign: "center" }}>
      <a
        href={RESUME_URL}
        download="Vedant_Gaidhane_DevOps_Engineer_2yrs.pdf"
        style={btnStyle}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 28px rgba(108,99,255,0.45)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "none";
          e.currentTarget.style.boxShadow = "0 4px 18px rgba(108,99,255,0.30)";
        }}
      >
        <AiOutlineDownload size={18} /> Download Resume
      </a>
    </div>
  );
}

const navBtnStyle = (disabled) => ({
  display: "flex", alignItems: "center", justifyContent: "center",
  width: 42, height: 42, borderRadius: "50%",
  background: "rgba(108,99,255,0.10)",
  border: "1px solid rgba(108,99,255,0.25)",
  color: disabled ? "var(--muted)" : "var(--primary)",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.4 : 1,
  transition: "all 0.2s ease",
  fontSize: "1.1rem",
});

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  }, []);

  const goPrev = () => setPageNumber((p) => Math.max(1, p - 1));
  const goNext = () => setPageNumber((p) => Math.min(numPages || 1, p + 1));

  return (
    <>
      <Helmet>
        <title>Resume | Vedant Gaidhane</title>
        <meta
          name="description"
          content="Resume of Vedant Gaidhane — Cloud & DevOps Engineer with AWS, Azure, DevSecOps, and FinOps & cloud cost optimization expertise."
        />
      </Helmet>
      <Container fluid className="resume-section">
        <Particle />
        <Container style={{ position: "relative", zIndex: 2 }}>

          <Row style={{ justifyContent: "center", marginBottom: "1.5rem" }}>
            <DownloadBtn />
          </Row>

          <Row
            style={{
              justifyContent: "center",
              alignItems: "center",
              gap: "1.2rem",
              marginBottom: "1rem",
            }}
          >
            <button
              type="button"
              onClick={goPrev}
              disabled={pageNumber <= 1}
              style={navBtnStyle(pageNumber <= 1)}
              aria-label="Previous page"
            >
              <AiOutlineLeft />
            </button>

            <span
              style={{
                color: "var(--muted)",
                fontSize: "0.9rem",
                fontWeight: 600,
                minWidth: 90,
                textAlign: "center",
              }}
            >
              Page {pageNumber} of {numPages || "…"}
            </span>

            <button
              type="button"
              onClick={goNext}
              disabled={numPages ? pageNumber >= numPages : true}
              style={navBtnStyle(numPages ? pageNumber >= numPages : true)}
              aria-label="Next page"
            >
              <AiOutlineRight />
            </button>
          </Row>

          <Row className="resume">
            <Document
              file={RESUME_URL}
              onLoadSuccess={onDocumentLoadSuccess}
              className="d-flex justify-content-center"
            >
              <Page pageNumber={pageNumber} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
          </Row>

          {numPages > 1 && (
            <Row style={{ justifyContent: "center", gap: "0.5rem", marginTop: "1.2rem" }}>
              {Array.from({ length: numPages }, (_, i) => i + 1).map((n) => (
                <button
                  key={n}
                  type="button"
                  onClick={() => setPageNumber(n)}
                  aria-label={`Go to page ${n}`}
                  style={{
                    width: 10, height: 10, borderRadius: "50%",
                    border: "none", padding: 0,
                    background: n === pageNumber ? "var(--primary)" : "rgba(108,99,255,0.25)",
                    cursor: "pointer",
                    transition: "background 0.2s ease",
                  }}
                />
              ))}
            </Row>
          )}

          <Row style={{ justifyContent: "center", marginTop: "1.5rem" }}>
            <DownloadBtn />
          </Row>

        </Container>
      </Container>
    </>
  );
}

export default ResumeNew;
